import React, { Component } from "react";
import { Form, Radio } from "semantic-ui-react";
import Modal from "../../../UIComponents/CustomModal/Modal";
import "./IrrPostModal.css";
import { toast } from "react-toastify";

const getBlockMessaage = ({ username, url, platform }) => {
    switch (platform) {
        case "twitter":
            return `All posts of X username "${username}" will be blocked.`;

        case "instagram":
            return `All posts of instagram username "${username}" will be blocked.`;
        case "facebook":
            return `All posts of facebook username "${username}" will be blocked.`;
        case "fbcomment":
            return `All comments of facebook username "${username}" will be blocked.`;
        case "pinterest":
            return `All posts of pinterest username "${username}" will be blocked.`;
        case "youtube":
            if (url.search("/UC") != -1) {
                return `All posts of youtube channel "${username}" will be blocked.`;
            }
            if (url.search("/user/") != -1) {
                return `All videos of youtube user "${username}" will be blocked.`;
            }
            return `All videos of the youtube channel "${username}" will be blocked.`;
        case "reddit":
            return `All posts of reddit page "${username}" will be blocked.`;
        default:
            url = getLocation(url).hostname;
            return `All posts of domain "${url}" will be blocked.`;
    }
};

var getLocation = function (href) {
    var l = document.createElement("a");
    l.href = href;
    return l;
};

class IrrPostModal extends Component {
    constructor(props) {
        super(props);

        this.state = {
            irrRadioVal: "duplicate",
            blockUrlText: this.props.blockUrl,
            othersText: "",
        };
    }

    UNSAFE_componentWillMount() {
        let currentPage = window.location.href;

        setInterval(() => {
            if (currentPage != window.location.href) {
                currentPage = window.location.href;
                this.props.hideModal();
            }
        }, 500);
    }

    UNSAFE_componentWillReceiveProps(newProps) {
        if (this.props.blockUrl !== newProps.blockUrl)
            this.setState({
                blockUrlText: newProps.blockUrl,
            });
    }

    handleBlockURLChange = ({ value: blockUrlText }) => {
        this.setState({ blockUrlText });
    };

    handleOthersTextChange = ({ value: othersText }) => {
        this.setState({ othersText });
    };

    handleRadioChange = (irrRadioVal) => {
        this.setState({ irrRadioVal });
    };

    handleHideIrrModalAccept() {
        let textVal = this.state.irrRadioVal === "block source" ? this.state.blockUrlText : this.state.othersText;
        if (this.state.irrRadioVal.toUpperCase() === "BLOCK SOURCE" && !textVal.trim().length) {
            toast.error("Block Source Url cannot be empty");
            return false;
        }
        this.props.hideModal();
        this.props.removeIrrPost(this.state.irrRadioVal, textVal);
    }

    getBlockSourceMessage = () => {
        if (!this.props.blockMessage) return;
        const message = getBlockMessaage(this.props.blockMessage);
        return this.props.blockUrl && ["facebook", "instagram", "fbcomment", "fbgroup"].indexOf(this.props.blockMessage?.platform) < 0 ? (
            <p className="modalImpMsg">({message})</p>
        ) : (
            <p className="modalImpMsg">(Please note that this option is unavailable for {this.platformName(this.props.blockMessage?.platform)} posts.)</p>
        );
    };

    platformName = (code) => {
        if (code === "instagram") return "Instagram";
        else if (code === "facebook") return "Facebook";
        else if (code === "fbcomment") return "Facebook Comments";
        else if (code === "fbgroup") return "Facebook Groups";
        else return "";
    };

    render() {
        return (
            <Modal className={`irrelevant-model`} show={this.props.open} onClose={() => this.props.hideModal()}>
                <Modal.Header>Mark Post As Irrelevant</Modal.Header>
                <Modal.Content>
                    <table>
                        <tbody>
                            <tr>
                                <td>
                                    <Radio
                                        label="Duplicate"
                                        name="radioGroup"
                                        value="duplicate"
                                        checked={this.state.irrRadioVal === "duplicate"}
                                        onChange={() => this.handleRadioChange("duplicate")}
                                    />
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <Radio
                                        label="Unwanted Ad"
                                        name="radioGroup"
                                        value="unwanted_ad"
                                        checked={this.state.irrRadioVal === "unwanted_ad"}
                                        onChange={() => this.handleRadioChange("unwanted_ad")}
                                    />
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <Radio
                                        label={`Block Source`}
                                        name="radioGroup"
                                        value="block source"
                                        disabled={["facebook", "instagram", "fbcomment", "fbgroup"].indexOf(this.props.blockMessage?.platform) > -1}
                                        checked={this.state.irrRadioVal === "block source"}
                                        onChange={() => this.handleRadioChange("block source")}
                                    />
                                </td>
                                <td>{this.getBlockSourceMessage()}</td>
                            </tr>
                            <tr>
                                <td>
                                    <Radio
                                        label="Others"
                                        name="radioGroup"
                                        value="others"
                                        checked={this.state.irrRadioVal === "others"}
                                        onChange={() => this.handleRadioChange("others")}
                                    />
                                </td>
                                <td>
                                    <Form.Input
                                        placeholder="Enter Description"
                                        value={this.state.othersText}
                                        onChange={(e, d) => this.handleOthersTextChange(d)}
                                    />
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </Modal.Content>
                <Modal.Actions>
                    <Modal.ActionButton normal onClick={() => this.props.hideModal()}>
                        Cancel
                    </Modal.ActionButton>
                    <Modal.ActionButton filled onClick={() => this.handleHideIrrModalAccept()}>
                        Save
                    </Modal.ActionButton>
                </Modal.Actions>
            </Modal>
        );
    }
}

export default IrrPostModal;
